export const SET_TEXT_FILTER = "SET_TEXT_FILTER";
export const SET_ADVANCED_FILTER = "SET_ADVANCED_FILTER";
